import { combineReducers } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authenticationInfo, {
  AuthenticationInfoActions,
} from "./authenticationInfos/authenticationInfo";
import oidc, { OidcActions } from "./oidc/oidc";
import yieldHistory, { YieldHistoryActions } from "./yieldHistory/yieldHistory";
import allocationHistory, { AllocationHistoryActions } from "./allocationHistory/allocationHistory";
import portfolioInformation, {
  PortfolioInformationActions,
} from "./portfolioInformation/portfolioInformation";
import statements, { StatementsActions } from "./statements/statements";
import transactions, { TransactionsActions } from "./transactions/transactions";
import yieldPerTimespan, { YieldPerTimespanActions } from "./yieldPerTimespan/yieldPerTimespan";
import yieldList, { YieldListActions } from "./yieldList/yieldList";
import privateEquityCapitalCall, {
  PrivateEquityCapitalCallActions,
} from "./privateEquityCapitalCall/privateEquityCapitalCall";
import distributions, { DistributionsActions } from "./distributions/distributions";
import assetClassParameters, {
  AssetClassParametersActions,
} from "./assetClassParameters/assetClassParameters";
import user, { UserActions } from "./user/user";
import summary, { SummaryActions } from "./summary/summary";
import assetClassDistribution, {
  AssetClassDistributionActions,
} from "./assetClassDistribution/assetClassDistribution";
import profitsAndLosses, { ProfitsAndLossesActions } from "./profitsAndLosses/profitsAndLosses";
import covenants, { CovenantsActions } from "./covenants/covenants";
import report, { ReportActions } from "./report/report";

export type RootState = ReturnType<typeof rootReducer>;
export type RootAction =
  | AuthenticationInfoActions
  | OidcActions
  | YieldHistoryActions
  | AllocationHistoryActions
  | PortfolioInformationActions
  | YieldPerTimespanActions
  | YieldListActions
  | DistributionsActions
  | TransactionsActions
  | AssetClassParametersActions
  | UserActions
  | StatementsActions
  | SummaryActions
  | AssetClassDistributionActions
  | ProfitsAndLossesActions
  | CovenantsActions
  | ReportActions
  | PrivateEquityCapitalCallActions;

export type RootDispatch = ThunkDispatch<RootState, undefined, RootAction>;

const userPersistConfig = {
  key: "user",
  storage,
  blacklist: ["reportDate", "startDate", "visibleSections"],
};

const rootReducer = combineReducers({
  authenticationInfo,
  oidc,
  yieldHistory,
  allocationHistory,
  portfolioInformation,
  yieldPerTimespan,
  yieldList,
  privateEquityCapitalCall,
  distributions,
  transactions,
  assetClassParameters,
  user: persistReducer(userPersistConfig, user),
  statements,
  summary,
  assetClassDistribution,
  profitsAndLosses,
  covenants,
  report,
});

export default rootReducer;
